<template>
  <div class="content-wrapper">
    <div class="flex-wrap items-center mb-4">  <!--프로젝트 초대 팝업-->
      <vs-tabs v-model="tabIndex">
        <vs-tab label="일정관리" @click="activeForm = 1" >
          <div></div>
        </vs-tab>
        <vs-tab label="캘린더" @click="activeForm = 2" >
          <div></div>
        </vs-tab>
        <vs-tab label="블로그" @click="activeForm = 3" >
          <div></div>
        </vs-tab>
        <vs-tab label="인사이트" @click="activeForm = 4" >
          <div></div>
        </vs-tab>
      </vs-tabs>
      <TaskMainJobList v-if="activeForm==1" v-on:selectTask="selectTask" />
      <Calendar  v-if="activeForm==2"/>
      <Blog  v-if="activeForm==3"/>
      <Insight  v-if="activeForm==4"/>
    </div>
  </div>
</template>

<script>
import TaskMainJobList from '@/views/apps/pms/task/TaskMainJobList.vue'
import Insight from '@/views/apps/pms/insight/Insight.vue'
import Calendar from '@/views/apps/pms/calendar/Calendar.vue'
import Blog from '@/views/apps/pms/blog/ProjectBlog.vue'
import vSelect from 'vue-select'

export default{
    components: {
        'TaskMainJobList': TaskMainJobList,
        'v-select': vSelect,
        'Insight': Insight,
        'Calendar': Calendar,
        'Blog': Blog,
    },
    data() {
      return {
        inviteTitle:'test',
        activeFormTest:false,
        activePrompt:false,
        activeForm:1,
        tabIndex:0
      }
    },
    watch: {
      '$route'() {
        // this.$store.dispatch('project/updateProject', {'id':this.projectInfo.id,'title':this.projectTitle})
        // this.$store.dispatch('project/getProjectMember',  Number(this.$route.params.projectId))
        // .then(()=>{
        //   this.$store.commit('project/SET_ACTIVE_USER_LEVEL', this.$store.state.AppActiveUser.uid)
        // })
        var project = this.$store.getters['project/getProject'](this.$route.params.projectId)
        if(project){
          this.$store.commit('project/SET_ACTIVE_PROJECT', project)
          this.$store.commit('project/SET_ACTIVE_USER_LEVEL', project.level)
        }
        this.$store.dispatch('task/getProjectMember',  this.$route.params.projectId).then(()=>{
          this.$store.dispatch('task/getDoneTask',  this.$route.params.projectId)
        })
      },
      workspaceProjects(){
        var project = this.$store.getters['project/getProject'](this.$route.params.projectId)
        if(project){
          this.$store.commit('project/SET_ACTIVE_PROJECT', project)
          this.$store.commit('project/SET_ACTIVE_USER_LEVEL', project.level)
        }
      }
    },
    computed: {
      // activeUserInfo() {
      //   return this.$store.state.AppActiveUser
      // },
      workspaceProjects(){
        return this.$store.state.project.workspaceProjects
      },
      activeProjectUserLevel() {
        return this.$store.state.project.ActiveProjectLevel
      },
    },
    created(){      
      if(this.$route.params.blogId != 0){
        this.activeForm = 3
        this.tabIndex = 2
        // this.$refs['taskTabs'].childActive = 2
      }
      this.$store.dispatch('task/getProjectMember',  this.$route.params.projectId).then(()=>{
        this.$store.dispatch('task/getDoneTask',  this.$route.params.projectId)
      })
      // .then(()=>{
      //   this.$store.commit('project/SET_ACTIVE_USER_LEVEL', this.$store.state.AppActiveUser.uid)
      // })
    },
    methods: {
      selectTask(){
        this.activeFormTest = true
      },
      acceptAlert(){
     this.$vs.notify({
       color:'success',
       title:'초대 수락!',
       text:'이제 프로젝트에서 함께 활동할 수 있어요.'
     })
   },
   close(){
     this.$vs.notify({
       color:'danger',
       title:'Closed',
       text:'You close a dialog!'
     })
   },
  }
}
</script>

<style>
body{font-family:'notokr'; background:#FFF;}
</style>
